<template>
  <div class="avg_marker" :style="markerStyle">
    <div class="avg_text" v-if="fitMode === 'width' && filmIndex === undefined" ref="markerText"
        :class="{isAttention: isAttention}"
        :style="textStyle">
      <span>
        {{ isAttention ? $t('common.averageFoldOver') : $t('common.averageFold').toUpperCase() }}
      </span>
    </div>
    <div class="avg_text_film" v-if="filmIndex !== undefined" ref="markerText" :style="textStyle">
      <span>
        {{ $t('common.averageFold').toUpperCase() }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeatmapAvgFold',
  props: [
    'avgFoldData',
    'scale',
    'fitMode',
    'isAttention',
    'filmIndex'
  ],
  data () {
    return {
      markerTextWidth: 0
    }
  },
  computed: {
    markerStyle () {
      const left = this.fitMode === 'width' ? this.markerTextWidth - 10 : 0
      return {
        top: (this.avgFoldData.avgFold * this.scale) + 'px',
        left: this.isAttention && this.filmIndex === undefined ? 0 : left + 'px',
        right: this.isAttention && this.filmIndex === undefined ? '117px' : null
      }
    },
    textStyle () {
      return {
        left: this.isAttention && this.filmIndex === undefined ? '100%' : -this.markerTextWidth + 10 + 'px',
        right: this.isAttention && this.filmIndex === undefined ? -100 + 'px' : null
      }
    }
  },
  watch: {
    fitMode (value) {
      this.$nextTick().then(() => {
        this.setMarkerTextWidth()
      })
    },
    isAttention () {
      this.$nextTick().then(() => {
        this.setMarkerTextWidth()
      })
    }
  },
  mounted () {
    this.setMarkerTextWidth()
  },
  methods: {
    setMarkerTextWidth () {
      if (this.$refs.markerText && !this.markerTextWidth) {
        this.markerTextWidth = this.$refs.markerText.offsetWidth
      } else {
        this.markerTextWidth = this.$refs.markerText.offsetWidth
      }
    }
  }
}
</script>

<style lang="scss">
.avg_marker {
  position: absolute;
  top: 0;
  right: 0;
  border-bottom: 2px dotted #fff;
  z-index: 100;
  pointer-events: none;

  .avg_text {
    position: absolute;
    bottom: -12px;
    font-size: 12px;
    color: #ffffff;
    background-image: url('../../assets/img/heatmap/heatmap_average_fold.svg');
    background-repeat: no-repeat;
    background-position: -10px -5px;
    line-height: 20px;
    text-indent: 4px;
    font-weight: 500;
    width: 110px;
    height: 40px;
    transform: translateY(19px);

    &.isAttention {
      text-align: center;
      width: 117px;
      background-image: url('../../assets/img/heatmap/heatmap_average_fold_right.svg');
    }
  }

  .avg_text_film {
    position: absolute;
    bottom: -11px;
    font-size: 12px;
    color: #ffffff;
    background-image: url('../../assets/img/heatmap/heatmap_average_fold_small.svg');
    background-repeat: no-repeat;
    background-position: 0 -5px;
    width: 97px;
    height: 20px;
    text-align: left;
    display: flex;
    align-items: center;

    span {
      margin-left: 4px;
      white-space: nowrap;
    }
  }
}
</style>
